import React from 'react';
import {Table} from 'semantic-ui-react';
import _ from 'lodash';

export const renderTitle = (wareHouseStock) => {
  return Object.keys(wareHouseStock).map((agencyName, index) => {
    return (
      <Table.HeaderCell key={index} width={2} textAlign='center' colSpan={2}>
        {agencyName.toLocaleUpperCase()}
      </Table.HeaderCell>
    );
  });
};

export const renderTable = (wareHouseStock) => {
  if (!Object.keys(wareHouseStock).length) {
    return (
      <Table.Body>
        <Table.Row>
          <Table.Cell textAlign='center'>No hay datos disponibles</Table.Cell>
        </Table.Row>
      </Table.Body>
    );
  }

  return (
    <Table.Body>
      {renderColumnsHeader(wareHouseStock)}
      {renderItems(wareHouseStock)}
      {renderTotalStock(wareHouseStock)}
    </Table.Body>
  );
};

function getArrayFromStockData(stockDetail) {
  const dealersAgenciesCounts = [];
  Object.keys(stockDetail).forEach((element) => {
    dealersAgenciesCounts.push(stockDetail[element].length);
  });
  const maxItem = Math.max(...dealersAgenciesCounts);

  const dataFormatted = [];
  Object.keys(stockDetail).forEach((element) => {
    for (let i = 0; i < maxItem; i++) {
      if (!dataFormatted[i]) {
        dataFormatted[i] = [];
      }
      dataFormatted[i].push(stockDetail[element][i]);
    }
  });
  return dataFormatted;
}

function renderColumnsHeader(wareHouseStock) {
  const wareHouseStockValues = Object.values(wareHouseStock);
  const columnsCount = wareHouseStockValues.length;

  const titlesColumns = [];
  for (let i = 0; i < columnsCount; ++i) {
    titlesColumns.push(<Table.Cell key={`${i}A`} textAlign='center'>Agencia</Table.Cell>);
    titlesColumns.push(<Table.Cell key={`${i}E`} textAlign='left'>Exist.</Table.Cell>);
  }
  return <Table.Row className='row-title'>{titlesColumns}</Table.Row>;
}

function renderItems(wareHouseStock) {
  const wareHouseStockLikeArray = getArrayFromStockData(wareHouseStock);
  const stockTableData = [];
  wareHouseStockLikeArray.forEach((agencies, index) => {
    const columnDataByAgency = [];
    agencies.forEach((agency, index1) => {
      columnDataByAgency.push(
        <Table.Cell key={`${index}${index1}A`} textAlign='center'>
          {agency ? renderAgencyCode(agency) : ''}
          {agency && agency.agencyName ? renderAgencyName(agency.agencyName) : ''}
        </Table.Cell>
      );
      columnDataByAgency.push(
        <Table.Cell key={`${index}${index1}E`} textAlign='center'>
          {agency && agency.stock ? agency.stock : ''}
        </Table.Cell>
      );
    });
    stockTableData.push(<Table.Row key={index}>{columnDataByAgency}</Table.Row>);
  });
  return stockTableData;
}

function renderAgencyCode(agency) {
  if (agency.agency) {
    return agency.agency;
  }
  if (agency.warehouse) {
    return agency.warehouse;
  }
  return '';
}

function renderAgencyName(name) {
  if (name.length <= 20) {
    return ` - ${name}`;
  }
  return ` - ${name.substring(0, 17)}...`;
}

function renderTotalStock(wareHouseStock) {
  const stockTotals = [];
  const wareHouseStockValues = Object.values(wareHouseStock);
  const columnsCount = wareHouseStockValues.length;

  for (let i = 0; i < columnsCount; ++i) {
    stockTotals.push(<Table.Cell key={`${i}T`} textAlign='center'>Total</Table.Cell>);
    stockTotals.push(<Table.Cell key={`${i}V`} textAlign='center'>
      {_.sumBy(wareHouseStockValues[i], 'stock')}
    </Table.Cell>);
  }
  return <Table.Row className='row-title'>{stockTotals}</Table.Row>;
}

export const getFactorValue = (factors, prefix, index = 0) => {
  if (!prefix || !factors || _.isEmpty(factors)) {
    return 0;
  }

  return index ? factors[`${prefix}${index}`] : factors[prefix];
};

export const getPartPrice = (fob = 0, {factors, factorIndex}, isGeneral = true) => {
  const prefix = isGeneral ? 'factorRetail' : 'factorWholesale';
  const priceFactor = getFactorValue(factors, prefix, factorIndex);

  return Number((priceFactor * fob).toFixed(2));
};
